import { HAS_PARENT_APP } from './consts';
import { publishMessageToParentApp } from './utils';

const setParentSearchParamsFn = (searchParams: string) => {
  return `
    parentWindow.history.replaceState('','','${searchParams}')
  `;
};

export const setParentSearchParams = (searchParams: URLSearchParams): void => {
  const queryString = `?${searchParams.toString()}`;

  if (!HAS_PARENT_APP) return window.history.replaceState('', '', queryString);

  publishMessageToParentApp(setParentSearchParamsFn(queryString));
};
